import React, { useState, useEffect } from "react";
import {
  validateImageUrl,
  useValidatedImageUrl,
} from "../../hooks/useValidatedImageUrl";

export interface ValidatedImageProps {
  imageUrl: string;
  fallbackUrl: string;
  alt: string;
  className?: string;
}

export const ValidatedImage: React.FC<ValidatedImageProps> = ({
  imageUrl,
  fallbackUrl,
  alt,
  className = "",
}) => {
  const { validatedUrl, isValidating } = useValidatedImageUrl(
    imageUrl,
    fallbackUrl
  );

  if (isValidating) {
    return <div className={`${className} loading`}>...</div>;
  }

  if (validatedUrl === fallbackUrl) {
    return <img src={fallbackUrl} alt={alt} className={className} />;
  }

  return <img src={validatedUrl} alt={alt} className={className} />;
};

export { useValidatedImageUrl, validateImageUrl };
